import CaseCopyToolContainer from './CaseCopyToolContainer';

export default CaseCopyToolContainer;
